export const DEBT_BALANCES_CONFIRMED_PREFIX = '[debt-balances-confirmed]';

export interface DebtBalanceEntry {
    type: string;
    label: string;
    /** Balance in whole dollars (e.g. 5000 means $5,000). */
    value: number;
}

export interface DebtBalancesConfirmedPayload {
    balances: DebtBalanceEntry[];
}

export const buildDebtBalancesConfirmedMessage = ({
    displayText,
    payload,
}: {
    displayText: string;
    payload: DebtBalancesConfirmedPayload;
}): string =>
    `${displayText}\n${DEBT_BALANCES_CONFIRMED_PREFIX} ${JSON.stringify(payload)}`;

export const parseDebtBalancesConfirmedMessage = (
    text: string,
): DebtBalancesConfirmedPayload | null => {
    const prefixIndex = text.indexOf(DEBT_BALANCES_CONFIRMED_PREFIX);
    if (prefixIndex === -1) {
        return null;
    }

    const jsonPayload = text
        .slice(prefixIndex + DEBT_BALANCES_CONFIRMED_PREFIX.length)
        .trim();

    try {
        const parsed: unknown = JSON.parse(jsonPayload);
        if (
            typeof parsed !== 'object' ||
            parsed == null ||
            !Array.isArray((parsed as DebtBalancesConfirmedPayload).balances)
        ) {
            return null;
        }
        return parsed as DebtBalancesConfirmedPayload;
    } catch {
        return null;
    }
};

export const formatDebtBalancesUserMessageForDisplay = (
    text: string,
): string => {
    if (!text.includes(DEBT_BALANCES_CONFIRMED_PREFIX)) {
        return text;
    }
    const prefixIndex = text.indexOf(DEBT_BALANCES_CONFIRMED_PREFIX);
    return text.slice(0, prefixIndex).trimEnd();
};
